import React, { useContext } from 'react'
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    ArcElement,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { useMediaQuery } from 'react-responsive';
import { ThemeContext } from '../../../auth';

ChartJS.register(ArcElement, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function ChartBar({ monthlyLead }) {

    const { theme } = useContext(ThemeContext);
    const isMobile = useMediaQuery({ maxWidth: 767 });

    const totalLeadData = Object?.values(monthlyLead?.totalLead || {});
    const successLeadData = Object?.values(monthlyLead?.successLead || {});

    const labels = [
        'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
        'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];

    const dataMobile = {
        labels,
        datasets: [
            {
                label: 'Total Leads',
                backgroundColor: theme === 'light' ? '#12B3ED' : '#006CB8',
                borderColor: theme === 'light' ? '#12B3ED' : '#006CB8',
                borderWidth: 1,
                data: totalLeadData,
                barThickness: 15,
                borderRadius: {
                    topLeft: 0,
                    topRight: 10,
                    bottomLeft: 0,
                    bottomRight: 10
                },
            },
            {
                label: 'Successful Leads',
                backgroundColor: theme === 'light' ? '#816fc0' : '#00B894',
                borderColor: theme === 'light' ? '#816fc0' : '#00B894',
                borderWidth: 1,
                data: successLeadData,
                barThickness: 15,
                borderRadius: {
                    topLeft: 0,
                    topRight: 10,
                    bottomLeft: 0,
                    bottomRight: 10
                },
            },
        ],
    };

    const optionsMobile = {
        responsive: true,
        plugins: {
            legend: {
                display: false,
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return `${context.dataset.label}: ${context.raw}`;
                    },
                },
            },
        },
        scales: {
            x: {
                display: false,
            },
            y: {
                ticks: {
                    color: theme === 'light' ? 'white' : '#222',
                    font: {
                        family: 'Poppins-Regular',

                    },
                },
                grid: {
                    display: false,
                },
                border: {
                    display: false,
                },
            },
        },
        indexAxis: 'y',
    };

    const dataDekstop = {
        labels,
        datasets: [
            {
                label: 'Total Lead',
                backgroundColor: theme === 'light' ? '#12B3ED' : '#8979FF',
                borderColor: theme === 'light' ? '#12B3ED' : '#8979FF',
                borderWidth: 1,
                data: totalLeadData,
                barThickness: 15,
                borderRadius: {
                    topLeft: 10,
                    topRight: 10,
                    bottomLeft: 0,
                    bottomRight: 0
                },
            },
            {
                label: 'Successful Lead',
                backgroundColor: theme === 'light' ? '#FF928A' : '#FF928A',
                borderColor: theme === 'light' ? '#FF928A' : '#FF928A',
                borderWidth: 1,
                data: successLeadData,
                barThickness: 15,
                borderRadius: {
                    topLeft: 10,
                    topRight: 10,
                    bottomLeft: 0,
                    bottomRight: 0
                },
            },
        ],
    };

    const optionsDekstop = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'bottom',
                labels: {
                    color: theme === 'light' ? 'white' : '#222',
                    font: {
                        family: 'Poppins-Regular',
                    },
                },
            },
            tooltip: {
                callbacks: {
                    label: function (context) {
                        return `${context.dataset.label}: ${context.raw}`;
                    },
                },
            },
        },
        scales: {
            x: {
                ticks: {
                    color: theme === 'light' ? 'white' : '#222',
                    font: {
                        family: 'Poppins-Regular',

                    },
                },
                grid: {
                    display: true,
                },
                border: {
                    display: true,
                },
            },
            y: {
                grid: {
                    display: true,
                },
            },
        },
        indexAxis: isMobile ? 'y' : 'x',
    };


    const d = new Date();
    let year = d.getFullYear();

    return (
        <div className="h-100">
            <p
                className="ps-1 pt-2 text-start"
                style={{
                    marginBottom: '20px',
                    fontFamily: 'Poppins-Bold',
                    fontSize: '20px',
                    color: theme === 'light' ? '#FFFFFF' : '#222',
                }}
            >
                Monthly Lead ({year})
            </p>
            {isMobile ? (
                <Bar
                    data={dataMobile}
                    options={optionsMobile}
                    height={500}
                    className="py-3 px-3"
                />
            ) : (
                <Bar
                    data={dataDekstop}
                    options={optionsDekstop}
                    height={170}
                    className="ps-1"
                />
            )}
        </div>
    );
}

export default ChartBar
